import { SearchClient } from "algoliasearch/lite";
import { SearchParameters } from "../../Search/Scripts/Models/Configuration/search-parameters";
import { InstantSearch } from "instantsearch.js/es/types";
import { CookieService } from "../services/cookie-service";
import { SnackBarService } from "../services/snackbar-service";
import { SnackBarParams } from "./snackbar-params";

export class BasePageModel {
    private _isConnected: boolean;
    isInit: Promise<void>;
    searchParams: SearchParameters = new SearchParameters();
    instantSearchClient: InstantSearch;
    searchClient: SearchClient;
    hasHeader: boolean = false;
    isDarkModeEnabled = true; 
    state: PageState = new PageState();

    public get isConnected() {
        var token = CookieService.getCookie("SRP");
        return token && token != '';
    }
}

export class PageState {
    isSearchPage: boolean = false;
    isShop: boolean = false;
    isSeller: boolean = false;
}

export function handleUnloggedUser() {
    let paramsSnackBar = new SnackBarParams(`/?direction=${encodeURIComponent(location.pathname)}${encodeURIComponent(location.search)}`, "go_to_login_page");
    paramsSnackBar.isTitleTranslated = false;
    paramsSnackBar.isMessageTranslated = false;
    SnackBarService.load("err_login_msg", paramsSnackBar);
    return;
}